import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { s3baseUri } from "../../config/config";
import { Visibility } from "@mui/icons-material";
import InsertDriveFileOutlined from "@mui/icons-material/InsertDriveFileOutlined";
import moment from "moment";
import { enqueueSnackbar } from "notistack";
import CustomMUITable from "../../components/customtable/CustomMuiTable";
import PageLoading from "../../components/loader/PageLoading";
import { candidates_list_api } from "../../DAL/partner/partners";
import { useIds } from "../../hook/AdminContext";
import { show_proper_words } from "../../utils/Constant";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Avatar,
  Grid,
  IconButton,
  Tooltip,
} from "@mui/material";
import {
  PictureAsPdfOutlined,
  DescriptionOutlined,
  SettingsSystemDaydream,
} from "@mui/icons-material";
import DocumentPreview from "../interview/previewDocument";
import DocumentModelBox from "../interview/DocumentModalBox";
import DocumentModalboxCv from "../interview/DocumentModalBoxcv";

const Candidates2 = () => {
  const [membersList, setMembersList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [openDetailPopup, setOpenDetailPopup] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewUrl, setPreviewUrl] = useState("");
  const [cvDialogOpen, setCvDialogOpen] = useState(false);
  console.log(selectedMember, "selectedMemberselectedMemberselectedMember");

  const { findId, setBreadCrumb } = useIds();
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const [dataapi, setDataApi] = useState();

  const handleChangeRowsPerPage = (event) => {
    setIsLoading(true);
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handlePreviewClick = (row) => {
    setSelectedMember(row);
    setCvDialogOpen(true);
  };
  const handleClosePreview = () => {
    setPreviewOpen(false);
    setPreviewUrl("");
  };
  const handleCloseCvDialog = () => {
    setCvDialogOpen(false);
    setSelectedMember(null);
  };
  const handleDownloadAdditiondOC = async (documentPath) => {
    const fileUrl = `${s3baseUri}${documentPath}`;
    const filename = documentPath.split("/").pop();

    try {
      const response = await fetch(fileUrl, { mode: "cors" });
      const blob = await response.blob();

      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Error downloading file:", error);
    } finally {
    }
  };

  const TABLE_HEAD = [
    { id: "action", label: "Action", type: "action" },
    { id: "number", label: "#", type: "number" },
    { id: "name_profile", label: "Image ", type: "title_with_img" },
    { id: "firs_name", label: "First Name" },
    { id: "last_name", label: "Last Name" },

    // {
    //   id: "email",
    //   label: "Email",
    //   type: "email",
    //   renderData: (row) => {
    //     const handleEmailClick = () => {
    //       // Safely get email and name with fallbacks
    //       const email = row?.email;
    //       const name = row?.name || "";

    //       // Create properly encoded URL
    //       const gmailUrl =
    //         `https://mail.google.com/mail/u/0/#inbox?compose=new` +
    //         `&to=${encodeURIComponent("zeeshankhalid1796@gmail.com")}` +
    //         `&su=${encodeURIComponent(`Regarding ${name}'s account`)}` +
    //         `&body=${encodeURIComponent(`Hello ${name},\n\n`)}`;

    //       window.open(gmailUrl, "_blank", "noopener,noreferrer");
    //     };

    //     return (
    //       <a
    //         href={`mailto:${"zeeshankhalid1796@gmail.com"}`}
    //         onClick={(e) => {
    //           e.preventDefault();
    //           handleEmailClick();
    //         }}
    //         style={{
    //           cursor: "pointer",
    //           color: "blue",
    //           textDecoration: "underline",
    //         }}
    //         title={`Email ${row.email}`}
    //       >
    //         {row.email}
    //       </a>
    //     );
    //   },
    // },
    {
      id: "email",
      label: "Email",
      type: "email",
      renderData: (row) => {
        const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&to=${row.email}`;

        return (
          <a
            href={gmailLink}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              cursor: "pointer",
              color: "blue",
              textDecoration: "underline",
            }}
          >
            {row.email}
          </a>
        );
      },
    },
    { id: "date_of_birth", label: "Applied  At" },
    {
      id: "cv",
      label: "CV",
      renderData: (row) => {
        return (
          <Tooltip title="Preview/Download CV">
            <IconButton
              onClick={() => handlePreviewClick(row)}
              sx={{ color: "navy" }}
            >
              <Visibility sx={{ fontSize: 28 }} />
            </IconButton>
          </Tooltip>
        );
      },
    },
  ];
  const docs = [
    {
      uri: s3baseUri + dataapi?.cv,
      name: dataapi?.cv,
    },
  ];
  const firstSegment = location.pathname.split("/")[1];

  const fetchData = async () => {
    const response = await candidates_list_api(params.id);
    console.log(response, "responseresponseresponseresponse");

    if (response.code === 200) {
      const members = response.job_application?.leaders.map((member) => ({
        ...member,
        name_profile: {
          image: s3baseUri + member?.created_by?.profile_image,
        },
        firs_name:
          member.created_by?.first_name ?? member.created_by?.company_name,
        last_name: member.created_by?.last_name ?? "NA",
        date_of_birth: moment(member?.createdAt).format("DD/MM/YYYY hh:mm A"),
        biography: member?.biography,
        email: member?.created_by?.user_id?.email,
        cv: member.cv,
      }));

      setTotalCount(members.length);
      setTotalPages(Math.ceil(members.length / rowsPerPage));
      setMembersList(members);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };
  const getFileExtension = (url) => {
    console.log(url, "urlurlurlurlurlurl");
    try {
      return url.split(".").pop().split("?")[0].toLowerCase();
    } catch {
      return "";
    }
  };

  const handleDownloadClick = async () => {
    console.log(selectedMember, "selectedMemberselectedMember");

    if (selectedMember?.cv) {
      try {
        const response = await fetch(s3baseUri + selectedMember.cv, {
          mode: "cors",
        });

        if (!response.ok) {
          throw new Error("Failed to fetch file");
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        const fileExtension = selectedMember.cv.split(".").pop();

        const firstName = selectedMember.firs_name
          ? selectedMember.firs_name.trim()
          : "";
        let lastName = selectedMember.last_name
          ? selectedMember.last_name.trim()
          : "";
        if (["N/A", "NA", "n/a", "na"].includes(lastName.toUpperCase())) {
          lastName = "";
        }
        const fullName =
          `${firstName} ${lastName}`.trim().replace(/\s+/g, "_") ||
          "unknown_user";

        const fileName = `CV_${fullName}.${fileExtension}`;

        // Create a link element
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Revoke the object URL after download
        window.URL.revokeObjectURL(url);
      } catch (error) {
        enqueueSnackbar("Error downloading the file", { variant: "error" });
        console.error("Download error:", error);
      }
    } else {
      enqueueSnackbar("No CV available to download", { variant: "error" });
    }
  };
  useEffect(() => {
    setBreadCrumb([
      {
        name: `${show_proper_words(firstSegment)}`,
        path: `/${firstSegment}`,
        active: false,
      },
      //   {
      //     name: `Live Job Feed`,
      //     path: `/${firstSegment}/live-job-feed`,
      //     active: false,
      //   },
      { name: `Candidates`, path: ``, active: true },
    ]);
  }, []);

  useEffect(() => {
    fetchData();
  }, [page, rowsPerPage]);

  const handleDetailPopUp = (member) => {
    setSelectedMember(member);
    setOpenDetailPopup(true);
  };

  const handleCloseDetailPopup = () => {
    setOpenDetailPopup(false);
    setSelectedMember(null);
  };
  console.log(selectedMember, "selectedMemberselectedMemberselectedMember");
  const MENU_OPTIONS = [
    {
      label: "View Details",
      icon: "bxs:detail",
      handleClick: handleDetailPopUp,
    },
  ];

  if (isLoading) return <PageLoading />;

  return (
    <>
      <DocumentModalboxCv
        open={cvDialogOpen}
        handleClose={handleCloseCvDialog}
        image_url={selectedMember?.cv ? s3baseUri + selectedMember.cv : ""}
        type={getFileExtension(selectedMember?.cv)}
        previewDoc={selectedMember}
        data={selectedMember}
      />

      <div className="container-fluid">
        <div className="row">
          <div className="col-6 my-2 main-heading-live-jobs">
            <h4>Candidates</h4>
          </div>
          <div className="col-12">
            <CustomMUITable
              TABLE_HEAD={TABLE_HEAD}
              data={membersList}
              pagePagination={true}
              MENU_OPTIONS={MENU_OPTIONS}
              custom_pagination={{
                total_count: totalCount,
                rows_per_page: rowsPerPage,
                page: page,
                handleChangePage: handleChangePage,
                onRowsPerPageChange: handleChangeRowsPerPage,
              }}
              totalPages={totalPages}
            />
          </div>
        </div>

        {/* Detail Popup */}
        <Dialog
          open={openDetailPopup}
          onClose={handleCloseDetailPopup}
          fullWidth
          maxWidth="md"
        >
          <DialogTitle
            variant="h6"
            sx={{ fontWeight: "bold", fontSize: "23px" }}
          >
            Candidate Details
          </DialogTitle>
          <DialogContent dividers>
            {selectedMember && (
              <Grid container spacing={2}>
                <Grid item xs={12} container alignItems="center" spacing={2}>
                  <Grid item>
                    <Avatar
                      src={selectedMember.name_profile.image}
                      sx={{ width: 80, height: 80 }}
                    />
                  </Grid>
                  <Grid item>
                    <Typography variant="h6">
                      {selectedMember.firs_name}{" "}
                      {selectedMember?.last_name === "NA"
                        ? ""
                        : selectedMember?.last_name}
                    </Typography>
                    <Typography variant="body2" color="subtitle1">
                      {selectedMember?.email}
                    </Typography>
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="subtitle1">
                    <strong style={{ fontWeight: "bold" }}>Applied At</strong>{" "}
                  </Typography>
                  <Typography>{selectedMember.date_of_birth}</Typography>
                </Grid>
                <Grid item xs={12} sx={{ paddingTop: "4px !important" }}>
                  {selectedMember?.job_description && (
                    <Typography variant="subtitle1">
                      <strong style={{ fontWeight: "bold" }}>
                        Description
                      </strong>{" "}
                    </Typography>
                  )}
                  <Typography>{selectedMember.job_description}</Typography>
                </Grid>
                <Grid item xs={12} sx={{ paddingTop: "4px !important" }}>
                  <Typography variant="subtitle1">
                    <strong style={{ fontWeight: "bold" }}>CV</strong>{" "}
                  </Typography>

                  {selectedMember.cv && (
                    <Tooltip title="View Cv">
                      <IconButton
                        // onClick={() =>
                        //   window.open(s3baseUri + selectedMember.cv, "_blank")
                        // }
                        onClick={handleDownloadClick}
                        sx={{ color: "navy", marginLeft: 0 }}
                      >
                        {selectedMember.cv.endsWith(".pdf") ? (
                          <PictureAsPdfOutlined sx={{ fontSize: 35 }} />
                        ) : selectedMember.cv.endsWith(".docx") ||
                          selectedMember.cv.endsWith(".doc") ? (
                          <DescriptionOutlined sx={{ fontSize: 50 }} />
                        ) : null}
                      </IconButton>
                    </Tooltip>
                  )}
                  {/* <Typography>{selectedMember.cv}</Typography> */}
                </Grid>
              </Grid>
            )}
            {selectedMember?.additional_documents &&
              selectedMember?.additional_documents?.length > 0 && (
                <Grid item xs={12} sx={{ paddingTop: "4px !important" }}>
                  <Typography variant="subtitle1">
                    <strong style={{ fontWeight: "bold" }}>
                      Additional Documents
                    </strong>
                  </Typography>
                  <Grid container spacing={1}>
                    {selectedMember?.additional_documents?.map((doc, index) => (
                      <Grid item key={index}>
                        <Tooltip title={doc.split("/").pop()}>
                          <IconButton
                            onClick={() => handleDownloadAdditiondOC(doc)}
                            sx={{ color: "navy" }}
                          >
                            {doc.endsWith(".pdf") ? (
                              <PictureAsPdfOutlined sx={{ fontSize: 35 }} />
                            ) : doc.endsWith(".docx") ||
                              doc.endsWith(".doc") ? (
                              <DescriptionOutlined sx={{ fontSize: 35 }} />
                            ) : (
                              <InsertDriveFileOutlined sx={{ fontSize: 35 }} />
                            )}
                          </IconButton>
                        </Tooltip>
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
              )}
          </DialogContent>
          <DialogActions>
            <button
              className="small-button-contain-job-candidates"
              onClick={handleCloseDetailPopup}
              color="primary"
            >
              Close
            </button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default Candidates2;
